export const CustomizedError = (object) => {
    return Object.assign(new Error(),object)
}